import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  parseMarketingPlan,
  readPendingPlan,
  rememberPendingPlan,
  type MarketingPlan,
} from './marketing-plan'

/** Read `?plan=` and keep it in sessionStorage until checkout starts. */
export function useMarketingPlan(): MarketingPlan | null {
  const [searchParams] = useSearchParams()
  const fromQuery = parseMarketingPlan(searchParams.get('plan'))

  const [plan, setPlan] = useState<MarketingPlan | null>(() => {
    if (fromQuery) {
      rememberPendingPlan(fromQuery)
      return fromQuery
    }
    return readPendingPlan()
  })

  useEffect(() => {
    if (fromQuery) {
      rememberPendingPlan(fromQuery)
      setPlan(fromQuery)
      return
    }
    setPlan(readPendingPlan())
  }, [fromQuery])

  return plan
}
